<template>
  <v-container>
    <div class="d-flex justify-space-between">
      <!-- <div class="tabs-max-width"> -->
      <div class="">
        <v-tabs v-model="tab" grow mobile-breakpoint="768px" class="tab-btn-style">
          <v-tab class="c-tab" v-if="permitObj.upload"> Upload </v-tab>
          <v-tab class="c-tab" v-if="permitObj.assign"> Assign  </v-tab>
          <v-tab class="c-tab" v-if="permitObj.print">Print</v-tab>
          <v-tab class="c-tab" v-if="permitObj.chartView">Chart View</v-tab>
          <v-tab class="c-tab" v-if="permitObj.answerSheet">Answer Sheet</v-tab>
        </v-tabs>
      </div>
      <bread-crumbs :items="breadItems"></bread-crumbs>
    </div>

    <div class="nmt-1">
      <v-tabs-items v-model="tab">
        <v-tab-item v-if="permitObj.upload"> <UploadWorkSheet></UploadWorkSheet> </v-tab-item>
        <v-tab-item v-if="permitObj.print"> <PrintWorkSheet></PrintWorkSheet> </v-tab-item>
        <v-tab-item v-if="permitObj.assign"> <AssignedWorkSheet></AssignedWorkSheet> </v-tab-item>
        <v-tab-item v-if="permitObj.chartView"><WorkSheetChart></WorkSheetChart></v-tab-item>
        <v-tab-item v-if="permitObj.answerSheet"><AnswerSheet></AnswerSheet></v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
import BreadCrumbs from "../../../components/BreadCrumbs";
import UploadWorkSheet from "../../../components/WorkSheet/UploadWorkSheet.vue";
import PrintWorkSheet from "../../../components/WorkSheet/PrintWorkSheet.vue";
import AssignedWorkSheet from "../../../components/WorkSheet/AssignedWorkSheet.vue";
import WorkSheetChart from "../../../components/WorkSheet/WorkSheetChart.vue";
import AnswerSheet from "../../../components/WorkSheet/AnswerSheet.vue";
import { getPermitObjects } from '../../../utils/allowedPermissions';

export default {
  name: "WorkSheet",
  components: {
    PrintWorkSheet,
    BreadCrumbs,
    AssignedWorkSheet,
    UploadWorkSheet,
    WorkSheetChart,
    AnswerSheet
  },
  data() {
    return {
      tab: null,
      permitObj: {},
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard",
          },
        },
        {
          text: "Uploaded Work",
          disabled: true,
          to: {
            name: "WorkSheet",
          },
        },
      ],
    };
  },
  methods: {
    getPermittedArray() {
      let links = this.$store?.getters?.permissions;
      let pathName = "WorkSheet";
      this.permitObj = getPermitObjects(links, pathName);
    }
  },
  mounted() {
    this.getPermittedArray();
  },
};
</script>

<style  lang="scss">
.nmt-1 {
  margin-top: -12px;
}
.c-tab {
  background: #f2f0f0;
  transition: background-color 0.2s;
  &.v-tab--active {
    background: white;
  }
}
</style>
<style scoped>
.tabs-max-width {
  width: 500px;
}
@media only screen and (max-width: 768px) {
  .tabs-max-width {
    width: 100% !important;
    min-width: 100% !important;
  }
  .d-flex.justify-space-between {
    display: block !important;
  }
}
</style>